import { Component } from 'react';
import LocationHelper from 'webapp/helpers/location_helper';
import Actions from 'webapp/actions/actions';
import EventDrivenDispatchers from './event_driven_dispatchers';
import { isEqual } from '../helpers/generic_utils';

class BWComponent extends Component {
  /**
   *
   * @param props
   * @param urlStoreStateKey
   * @param initState
   * @param whiteListUrlStorage
   */
  constructor(
    props,
    urlStoreStateKey = [],
    initState,
    whiteListUrlStorage = ['czip', 'cfirstname', 'clastname', 'cemail']
  ) {
    super(props);
    this._urlStateProperties = [
      'auth',
      'companyName',
      'installerName',
      'r',
      'captcha',
      'marketType',
      'enhancedRemoteQuickCheck',
    ];
    this.urlState = {};

    this.urlStoreStateKey = Array.isArray(urlStoreStateKey) ? urlStoreStateKey : [];

    try {
      this.__constructorStack = new Error().stack;
      this.__debugName = this.__constructorStack
        .split('\n')[2]
        .split(' ')
        .filter((e) => e)[2];
    } catch (e) {}
    if (Array.isArray(urlStoreStateKey)) {
      let tmpState = {};
      urlStoreStateKey.forEach((stateKey) => {
        tmpState = LocationHelper.loadStateFromUrlQuery(initState, stateKey, whiteListUrlStorage);
      });
      this.urlState = LocationHelper.loadStateFromUrlQuery({}, null, this._urlStateProperties);
      this.state = tmpState;
    }
    this.whiteListUrlStorage = whiteListUrlStorage;

    this.bwComponentHasUnmounted = false;
  }

  getUrlState(key) {
    return this?.urlState?.[key];
  }

  propagateToDebug(data) {
    try {
      const name = this.__debugName;
      if (
        this.__constructorStack &&
        !this.__constructorStack.includes('QAHidden') &&
        !this.__constructorStack.includes('Debug') &&
        this.lessThanDebugCalls(3) // this function name is also debug. ontop of debug component...
      ) {
        EventDrivenDispatchers.dispatch(EventDrivenDispatchers.types.Debugger, { name, data });
      }
    } catch (e) {}
  }

  lessThanDebugCalls(max) {
    let count = 0;
    return (
      new Error().stack.replace(
        /Debug/g,
        (() => () => {
          count++;
          return '';
        })()
      ) && count < max
    );
  }

  componentWillUnmount() {
    this.bwComponentHasUnmounted = true;
  }

  isComponentUnmounted() {
    return !!this.bwComponentHasUnmounted;
  }

  shouldUpdateState(newStateObj, stateObj) {
    if (newStateObj === stateObj) {
      return false;
    }

    return Object.keys(newStateObj).some((key) => !isEqual(newStateObj[key], stateObj[key]));
  }

  setState(value, callback) {
    if (this.isComponentUnmounted()) {
      return;
    }
    if (this.shouldUpdateState(value, this.state)) {
      super.setState(value, callback);
      setTimeout(() => this.propagateToDebug(this.state), 10);
    }
  }

  __setState(value) {
    super.setState(value);
  }

  reRenderUrl() {
    if (Array.isArray(this.urlStoreStateKey)) {
      let componentStateAsQuery = LocationHelper.statesAsQuery(
        '?',
        this.urlStoreStateKey,
        this.whiteListUrlStorage,
        this.state
      );

      let componentAndSecretStateAsQuery = LocationHelper.statesAsQuery(
        componentStateAsQuery,
        null,
        this._urlStateProperties,
        this.urlState
      );

      Actions.setRoute(`${window.location.pathname}${componentAndSecretStateAsQuery}`);
    }
  }
}

export default BWComponent;
